'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toLocationTiers;

var _lodash = require('lodash.uniq');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function jobToTierName(job) {
  var locationMatch = job.locationMatch;


  switch (locationMatch) {
    case 'Exact':
      return 'tier1';
    case 'Nearby':
      return 'tier2';
    case 'Area':
      return 'tier3';
    default:
      return 'no tier';
  }
}

function toLocationTiers() {
  var jobs = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];

  return (0, _lodash2.default)(jobs.map(jobToTierName));
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/toLocationTiers.js
 ** module id = 436
 ** module chunks = 0
 **/